import M, { useState as d, useEffect as E, useRef as w, useImperativeHandle as k, useCallback as D, useLayoutEffect as B } from "react";
import { throttle as F } from "throttle-debounce";
import { canUseDOM as z, uniqueId as K, clamp as f, getBoundingClientRect as A } from "./util.mjs";
import { useEventCallback as l } from "./v2/hooks.mjs";
const N = (e = 150) => {
  const [n, t] = d(
    z() ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: void 0,
      height: void 0
    }
  );
  return E(() => {
    if (!z())
      return;
    const r = F(e, () => {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    });
    return window.addEventListener("resize", r), () => window.removeEventListener("resize", r);
  }, [e]), n;
}, b = () => {
  const [e, n] = d({}), [t, r] = d(null), o = D((i) => r(i), []);
  return B(() => {
    window.requestAnimationFrame(() => n(A(t)));
  }, [t]), E(() => {
    const i = () => n(A(t));
    return window.addEventListener("resize", i), () => window.removeEventListener("resize", i);
  }, [t]), [o, e];
};
function q(e) {
  const n = w(null);
  return k(e, () => n.current), n;
}
const x = (e, n) => w(e || K(n ? n.replace(/\s/g, "-") : "")).current;
function H(e, n, t) {
  const r = n || K(t ? t.replace(/\s/g, "-") : "");
  return e.reduce(
    (o, i) => ({
      ...o,
      [i]: `${r}-${i}`
    }),
    { id: r }
  );
}
function W(e, n, t) {
  return w(H(e, n, t)).current;
}
function $(e) {
  const [n, t] = M.useState(!1);
  return { hideFocus: n, onBlur: (s) => {
    var u;
    t(!1), (u = e == null ? void 0 : e.onBlur) == null || u.call(e, s);
  }, onKeyDown: (s) => {
    var u;
    t(!1), (u = e == null ? void 0 : e.onKeyDown) == null || u.call(e, s);
  }, onMouseDown: (s) => {
    var u;
    t(!0), (u = e == null ? void 0 : e.onMouseDown) == null || u.call(e, s);
  } };
}
const P = ({ value: e, onChange: n, onStart: t, onEnd: r }) => {
  const [o, i] = d(!1), s = w(!1), u = w(0), v = w(0), C = l(n), g = l(t), p = l(r), I = (m) => {
    m.preventDefault(), s.current = !0;
    const L = f(0, 1, e), { width: R, left: y } = m.currentTarget.getBoundingClientRect();
    u.current = R, v.current = y - (y - m.clientX) - R * L, i(!0), g == null || g(L);
  }, c = D((m) => {
    s.current && (s.current = !1, p == null || p(f(0, 1, (m.clientX - v.current) / u.current))), i(!1);
  }, []), a = D((m) => {
    C(f(0, 1, (m.x - v.current) / u.current));
  }, []);
  return E(() => (o ? (document.addEventListener("mouseup", c), document.addEventListener("mousemove", a), document.addEventListener("mouseleave", c)) : (document.removeEventListener("mouseup", c), document.removeEventListener("mousemove", a), document.removeEventListener("mouseleave", c)), () => {
    document.removeEventListener("mouseup", c), document.removeEventListener("mousemove", a), document.removeEventListener("mouseleave", c);
  }), [o]), { onMouseDown: I, onMouseUp: c, isDragging: o };
}, T = (e, n) => (t) => {
  if (!["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"].includes(t.key))
    return;
  t.preventDefault(), t.stopPropagation();
  const r = t.key === "ArrowRight" || t.key === "ArrowUp" ? 0.05 : -0.05;
  let o = 1;
  t.altKey ? o = 0.2 : t.shiftKey ? o = 4 : t.metaKey && (o = 8), n(f(0, 1, e + r * o));
};
export {
  T as useArrowKeysX,
  b as useDimensions,
  P as useDragX,
  q as useForwardedOrNewRef,
  $ as useHideFocusOnClick,
  W as useIds,
  x as useSuppliedOrNewId,
  N as useWindowSize
};
